'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function RecommendationEntryDataService(restangular, dataTransformService) {
  var recommendationLadderEndPoint = restangular.one('external').one('faresoptimizer').one('recommendationladder');
  function bulkExpireLadders(ladders) {
    return restangular.one('external').one('faresoptimizer').one('recommendationladder').one('expireRecommendationLadders').one('bulk').customPUT({
      value: ladders
    });
  }
  function updateStatusService(action) {
    return restangular.service('external/faresoptimizer/recommendationladder/' + action);
  }
  function updateOfferbasedFareLadderStatusService(action) {
    return restangular.service('external/offerFareLadder/' + action);
  }
  function updateEffectiveDateAndAuthNotesService() {
    return restangular.service('external/faresoptimizer/recommendationladder/updateEffectiveDate');
  }
  function updateEffectiveDateAndAuthNotesAdaptiveService() {
    return restangular.service('external/offerFareLadder/updateEffectiveDate');
  }
  function upsertLadder(payload) {
    return upsertLadderUtility(payload, recommendationLadderEndPoint);
  }
  function upsertLadderAndUpdateHostDetailsInCompLadder(payload) {
    return upsertLadderUtility(payload, recommendationLadderEndPoint.one('competitorfareladder'));
  }
  function upsertLadderUtility(payload, endPoint) {
    return endPoint.customPUT(payload).then(function () {
      toastr.success('Recommendation Ladder Saved');
    })["catch"](function () {
      toastr.error('Recommendation Ladder Save Failed');
      throw 'Recommendation Ladder Save Failed';
    });
  }
  function updateRecommendationStatus(action, payload, displayedRawData, rawData, selectedHostLadderData, marketRawDataChunks, currentPage, recommendMode) {
    var fareRecommendationApprovalService = recommendMode !== 'ADAPTIVE' ? updateStatusService(action) : updateOfferbasedFareLadderStatusService(action);
    var message = 'State Change';
    if (action === 'approve') {
      message = 'Approval';
    } else if (action === 'reject') {
      message = 'Rejection';
    } else if (action === 'undo') {
      message = 'Undo Initiated';
    }
    fareRecommendationApprovalService.post(payload).then(function (data) {
      var transformedLadderList = recommendMode !== 'ADAPTIVE' ? dataTransformService.transformRecommendationLadder(data) : dataTransformService.transformRecommendationLadderAdaptive(data);
      _.forEach(transformedLadderList, function (ladder) {
        var currentPageData = marketRawDataChunks[currentPage - 1];
        dataTransformService.updateRecommendation(displayedRawData, ladder, selectedHostLadderData, recommendMode);
        dataTransformService.updateRecommendation(rawData, ladder, selectedHostLadderData, recommendMode);
        dataTransformService.updateRecommendationInMarketChunks(currentPageData, ladder, selectedHostLadderData, recommendMode);
      });
      toastr.success(message + ' Successful');
    })["catch"](function () {
      toastr.error(message + ' Failed');
    });
  }
  function updateRecommendationEffDateAndNotes(payload, displayedRawData, rawData, selectedHostLadderData, recommendMode) {
    var fareRecommendationEffDateUpdateService = recommendMode !== 'ADAPTIVE' ? updateEffectiveDateAndAuthNotesService() : updateEffectiveDateAndAuthNotesAdaptiveService();
    var message = 'Updation';
    fareRecommendationEffDateUpdateService.post(payload).then(function (data) {
      var transformedLadderList = recommendMode !== 'ADAPTIVE' ? dataTransformService.transformRecommendationLadder(data) : dataTransformService.transformRecommendationLadderAdaptive(data);
      _.forEach(transformedLadderList, function (ladder) {
        dataTransformService.updateRecommendation(displayedRawData, ladder, selectedHostLadderData, recommendMode);
        dataTransformService.updateRecommendation(rawData, ladder, selectedHostLadderData, recommendMode);
      });
      toastr.success(message + ' Successful');
    })["catch"](function () {
      toastr.error(message + ' Failed');
    });
  }
  return {
    updateRecommendationStatus: updateRecommendationStatus,
    upsertLadder: upsertLadder,
    upsertLadderAndUpdateHostDetailsInCompLadder: upsertLadderAndUpdateHostDetailsInCompLadder,
    updateRecommendationEffDateAndNotes: updateRecommendationEffDateAndNotes,
    bulkExpireLadders: bulkExpireLadders
  };
}
RecommendationEntryDataService.$inject = ['Restangular', 'FaresOptimizerDataTransformerService'];
module.exports = RecommendationEntryDataService;